<template>
	<div class="themactdetail">
		<headerview :cur="3"></headerview>
		
		<div class="content">
			
			<div class="moddlecon w13">
				<div class="tipcon">
					<tipcon :title="'专题活动'" :name="'专题活动'" :imgtype="'1'" width="2.05"></tipcon>
				</div>
				
				<div class="carcon min-h">
					<div class="l_c">
						<div class="frame">
							<div class="signle" v-for="(item,index) in tablist" :key="index"
							@click="changetab(index)">
								<img class="" src="../../../static/img/mininav_cur@2x.png" alt=""/>
								<span :class="tabindex == index?'text_cur':'text'">{{item.className}}</span>
							</div>
						</div>
						
					</div>
					<div class="r_c">
						<div class="detailscon" v-if="ifdetail">
							<div class="title">{{informData.title || ''}}</div>
							<div class="timeandsource">{{informData.createTime || ''}} 
							<span style="margin-left: 20px;">来源:{{informData.source || ''}}</span></div>
							<div class="msg" v-html="informData.content"></div>
						</div>
						
						<div class="listcon_public" style="margin-left: 40px;" 
							 v-if="!ifdetail">
							<div class="signle" v-for="(item,index) in list" :key="index" @click="seedetail(item)">
								<div class="title overfh" :title="item.title">{{item.title || ''}}</div>
								<div class="time">{{item.createTime.split(' ')[0] || ''}}</div>
							</div>
						</div>
						
						<!-- 分页 -->
						<div class="" v-if="!ifdetail">
							<div v-if='pageShow' is='footPage' class="zhini-pagination"
							  :currentPage="pageNo"
							  :totalPage="total"
							  @pageNum="pageNum"  :pagesize='pageSize'></div>
						</div>
						
					</div>
						
				</div>	
				
			</div>
				
		</div>		
				
		<footview></footview>
		
	</div>
	
</template>

<script>

import tipcon from "../../../com/tipcon.vue";
import footPage from '../../../components/footpage/footpage.vue'
export default {
  components: {
  	  tipcon,
	  footPage,
  },
  data: function() {
    return {
		tabindex:0,
		tablist:[],
		ifdetail:false,
		pageNo:1,
		total:1,
		pageSize:8,
		
	    msg:"",
		id:"",
		list:[],
		informData:{},
		pageShow:true,
		
    };
  },
  
  mounted() {
	    if(this.$route.query) {
	  	  this.id = this.$route.query.id;
	    }
		this.$onScrollT()
		this.getItemClassList()
		
  },

  methods: {
	    //分类
	    getItemClassList(){
	    	  this.$get(`web/specialActivity/itemClassList`).then(res=>{
	    		  if(res.success){	
	    				this.tablist = res.result.records
						this.getSpecialDetail(this.tablist[this.tabindex].id)				
	    		  }
	    	  })
	    },
	  
	    //列表
	    getSpecialDetail(classId){
			this.pageShow=false;
			this.$nextTick(()=>{this.pageShow=true});
			  this.$get(`web/specialActivity/activityItemList/?classId=${classId}&specialId=${this.id}&pageSize=${this.pageSize}&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
					    this.total = res.result.total
						this.list = res.result.records				
				  }
			  })
	    },
		
		//详情
		getActivityDetail(id){
			  this.$get(`web/specialActivity/queryById?id=${id}`).then(res=>{
				    if(res.success){	
						this.informData = res.result			
				    }
			  })
		},
	  
		changetab(index){
		    this.tabindex = index
			this.ifdetail = false
			this.pageNo = 1;
			this.list = [];
			this.getSpecialDetail(this.tablist[index].id)		
		},
		
		seedetail(item){
			this.ifdetail = true
			this.getActivityDetail(item.id)			
		},
		
		pageNum(e) {
			this.pageNo = e;
			this.$onScrollT()
			this.getSpecialDetail(this.tablist[this.tabindex].id)
		},
		
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.themactdetail{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			
			.carcon{
				display: flex;
				.l_c{
					.frame{
						width: 202px;
						height: 100px;
						background: #FFFFFF;
						border: 1px solid #E6E6E6;
						.signle{
							cursor: pointer;
							height: 50px;
							display: flex;
							align-items: center;
							border-top: 1px solid #E6E6E6;
							img{
								margin-left: 10px;
								margin-right: 40px;
								width: 10px;
								height: 12px;
							}
							.text_cur{
								font-size: 18px;
								font-weight: 400;
								color: #E61F26;
							}
							.text{
								font-size: 18px;
								font-weight: 400;
								color: #000000;
							}
						}
					}
					
				}
				.r_c{
					flex: 1;
					.detailscon{
						margin-top: 20px;
						.title{
							height: 60px;
							line-height: 60px;
							font-size: 30px;
							font-weight: bold;
							text-align: center;
							color: #333333;
						}
						.timeandsource{
							height: 40px;
							line-height: 40px;
							font-size: 16px;
							text-align: center;
							color: #666666;
						}
						.msg{
							margin-left: 40px;
						}
						.msg::-webkit-scrollbar {
						    display: none;
						}
					}
				}
			}
			
			
		}
			
	}		
	
	
}

</style>

<style scoped>
/deep/ .msg img{
	max-width: 100%;
	vertical-align: middle
}
.listcon_public .signle .title,.title{
  width: calc(100% - 150px)!important;
}

</style>